/* Page « Tous les avis » — Veranelle
   Le corpus entier est chargé une fois, puis trié, filtré et paginé côté client.
   Conséquence : le tri et le filtre portent sur la totalité des avis, jamais sur
   la seule page affichée — et tous les compteurs dérivent des mêmes données,
   donc ils ne peuvent pas diverger. */

(() => {
  const racine = document.querySelector('[data-avis]');
  if (!racine) return;

  const retour = racine.querySelector('[data-retour-article]');
  const lienRetour = racine.querySelector('[data-retour-article-lien]');
  function articleValide(value) {
    if (!value) return null;
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin
        && url.pathname === window.location.pathname
        && url.searchParams.get('view') === 'advertorial' ? url : null;
    } catch { return null; }
  }
  const provenance = articleValide(document.referrer);
  const article = articleValide(new URL(window.location.href).searchParams.get('return_to')) || provenance;
  if (article && retour && lienRetour) {
    retour.hidden = false;
    lienRetour.href = article.href;
    lienRetour.addEventListener('click', event => {
      if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      if (provenance && provenance.href === article.href && window.history.length > 1) {
        event.preventDefault();
        window.history.back();
      }
    });
  }

  const PAS = 20;
  const CHEMIN_ETOILE = 'M12 2.75l2.78 5.63 6.22.9-4.5 4.39 1.06 6.2L12 16.94 6.44 19.87l1.06-6.2L3 9.28l6.22-.9L12 2.75z';
  const $ = (s) => racine.querySelector(s);

  const els = {
    squelette: $('[data-squelette]'),
    contenu: $('[data-contenu]'),
    erreur: $('[data-erreur]'),
    chiffre: $('[data-moyenne]'),
    fraction: $('[data-fraction]'),
    total: $('[data-total]'),
    periode: $('[data-periode]'),
    filtreSel: $('[data-filtre]'),
    liste: $('[data-liste]'),
    statut: $('[data-statut]'),
    tri: $('[data-tri]'),
    plus: $('[data-plus]'),
    boutonPlus: $('[data-plus] button'),
    vide: $('[data-vide]'),
  };

  const dateFr = new Intl.DateTimeFormat('fr-FR', {
    day: 'numeric', month: 'long', year: 'numeric',
  });
  const nombreFr = new Intl.NumberFormat('fr-FR');

  let corpus = [];
  let filtre = null;   // null = tout, sinon 1..5
  let visibles = PAS;

  /* ---------- étoiles ---------- */

  function etoiles(note, classe) {
    const n = document.createElement('span');
    n.className = `avis-etoiles ${classe || ''}`.trim();
    for (let i = 1; i <= 5; i += 1) {
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('aria-hidden', 'true');
      if (note === null || i <= note) svg.classList.add('est-pleine');
      const p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      p.setAttribute('d', CHEMIN_ETOILE);
      svg.appendChild(p);
      n.appendChild(svg);
    }
    return n;
  }

  /* ---------- synthèse ---------- */

  function peindreSynthese() {
    els.chiffre.textContent = corpus.moyenne.toLocaleString('fr-FR', {
      minimumFractionDigits: 1, maximumFractionDigits: 2,
    });

    els.fraction.setAttribute(
      'aria-label',
      `Noté ${corpus.moyenne.toLocaleString('fr-FR')} sur 5 d'après ${nombreFr.format(corpus.total)} avis`,
    );
    const vide = etoiles(0, 'avis-etoiles--score');
    els.fraction.append(vide);
    const pleines = document.createElement('span');
    pleines.className = 'avis-etoiles__pleines';
    pleines.append(etoiles(null, 'avis-etoiles--score'));
    els.fraction.append(pleines);

    // Le remplissage est mesuré, pas calculé en pourcentage de la largeur totale.
    // Un pourcentage naïf ignore les espaces entre étoiles et sur-remplit ; et comme
    // une étoile est plus large en son milieu, une coupe aux deux tiers se lit
    // « pleine ». On arrondit donc le graphique au demi-point — le chiffre exact
    // reste affiché juste à côté.
    const remplir = () => {
      const arrondie = Math.round(corpus.moyenne * 2) / 2;
      const branches = [...vide.children];
      if (!branches.length) return;
      const gauche = vide.getBoundingClientRect().left;
      const entier = Math.floor(arrondie);
      const demi = arrondie - entier;
      let bord;
      if (entier === 0) {
        bord = 0;
      } else if (demi === 0) {
        bord = branches[entier - 1].getBoundingClientRect().right - gauche;
      } else {
        const suivante = branches[entier].getBoundingClientRect();
        bord = suivante.left - gauche + suivante.width * demi;
      }
      els.fraction.style.setProperty('--av-remplissage', `${bord}px`);
    };
    remplir();
    window.addEventListener('resize', remplir);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remplir);

    els.total.textContent = `${nombreFr.format(corpus.total)} avis publiés`;
    els.periode.textContent =
      `du ${dateFr.format(new Date(corpus.periode.debut))} au ${dateFr.format(new Date(corpus.periode.fin))}`;

    for (let note = 5; note >= 1; note -= 1) {
      const effectif = corpus.repartition[note] || 0;
      if (!effectif) continue;
      const opt = document.createElement('option');
      opt.value = String(note);
      opt.textContent = `${note} étoile${note > 1 ? 's' : ''} (${nombreFr.format(effectif)})`;
      els.filtreSel.appendChild(opt);
    }
  }

  /* ---------- liste ---------- */

  function selection() {
    const base = filtre === null ? corpus.avis : corpus.avis.filter((a) => a.n === filtre);
    const selectedId = new URL(window.location.href).searchParams.get('avis');
    if (selectedId && filtre === null && els.tri.value === 'recent') {
      const selected = base.find(a => a.i === selectedId);
      if (selected) return [selected, ...base.filter(a => a.i !== selectedId)];
    }
    const mode = els.tri.value;
    if (mode === 'recent') return base;                                   // déjà trié à l'export
    const copie = base.slice();
    copie.sort((x, y) => (mode === 'haute' ? y.n - x.n : x.n - y.n)
      || (x.d < y.d ? 1 : x.d > y.d ? -1 : 0));
    return copie;
  }

  function carte(avis) {
    const li = document.createElement('li');
    li.className = 'avis-item';
    li.id = `avis-${avis.i}`;

    const meta = document.createElement('div');
    meta.className = 'avis-item__meta';

    const notes = etoiles(avis.n, 'avis-etoiles--item');
    notes.setAttribute('role', 'img');
    notes.setAttribute('aria-label', `Noté ${avis.n} sur 5`);

    const time = document.createElement('time');
    time.className = 'avis-item__date';
    time.dateTime = avis.d;
    time.textContent = dateFr.format(new Date(avis.d));

    meta.append(notes, time);
    li.append(meta);

    if (avis.t) {
      const h3 = document.createElement('h3');
      h3.className = 'avis-item__titre';
      h3.textContent = avis.t;          // textContent : jamais d'injection
      li.append(h3);
    }

    const p = document.createElement('p');
    p.className = 'avis-item__texte';
    p.textContent = avis.c;
    li.append(p);

    return li;
  }

  function peindreListe() {
    const lot = selection();
    const affiches = lot.slice(0, visibles);

    els.liste.replaceChildren(...affiches.map(carte));
    els.vide.hidden = lot.length !== 0;
    els.plus.hidden = affiches.length >= lot.length;

    if (!els.plus.hidden) {
      const reste = lot.length - affiches.length;
      els.boutonPlus.textContent =
        `Voir ${nombreFr.format(Math.min(PAS, reste))} avis de plus`;
    }

    els.statut.textContent = filtre === null
      ? `${nombreFr.format(affiches.length)} avis affichés sur ${nombreFr.format(lot.length)}`
      : `${nombreFr.format(affiches.length)} avis affichés sur ${nombreFr.format(lot.length)} notés ${filtre} sur 5`;

    els.filtreSel.value = filtre === null ? '' : String(filtre);
  }

  /* ---------- interactions ---------- */

  function appliquerFiltre(note) {
    filtre = note;
    visibles = PAS;
    majUrl();
    peindreListe();
  }

  function majUrl() {
    const url = new URL(window.location.href);
    if (filtre === null) url.searchParams.delete('note');
    else url.searchParams.set('note', String(filtre));
    window.history.replaceState({}, '', url);
  }

  function lireUrl() {
    const n = Number(new URL(window.location.href).searchParams.get('note'));
    if (Number.isInteger(n) && n >= 1 && n <= 5) filtre = n;
  }

  /* ---------- démarrage ---------- */

  fetch(racine.dataset.avisUrl, { credentials: 'omit' })
    .then((r) => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      return r.json();
    })
    .then((data) => {
      corpus = data;
      if (!Array.isArray(corpus.avis) || corpus.avis.length === 0) {
        throw new Error('corpus vide');
      }
      lireUrl();
      peindreSynthese();
      peindreListe();
      els.squelette.hidden = true;
      els.contenu.hidden = false;
      const id = new URL(window.location.href).searchParams.get('avis');
      if (id && /^AV-\d+$/.test(id)) {
        const selected = document.getElementById('avis-' + id);
        if (selected) {
          selected.tabIndex = -1;
          requestAnimationFrame(() => { selected.scrollIntoView({ block:'center' }); selected.focus({ preventScroll:true }); });
        }
      }
    })
    .catch(() => {
      els.squelette.hidden = true;
      els.erreur.hidden = false;
    });

  els.tri.addEventListener('change', () => { visibles = PAS; peindreListe(); });
  els.filtreSel.addEventListener('change', (e) => {
    const v = e.target.value;
    appliquerFiltre(v === '' ? null : Number(v));
  });
  els.boutonPlus.addEventListener('click', () => {
    const avant = els.liste.children.length;
    visibles += PAS;
    peindreListe();
    els.liste.children[avant]?.scrollIntoView({ block: 'nearest' });
  });
})();
